import { render, staticRenderFns } from "./Give.vue?vue&type=template&id=4c9dcc85&scoped=true&"
import script from "./Give.vue?vue&type=script&lang=js&"
export * from "./Give.vue?vue&type=script&lang=js&"
import style0 from "./Give.vue?vue&type=style&index=0&id=4c9dcc85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9dcc85",
  null
  
)

export default component.exports